// import ResizableBox from "../ResizableBox";
import React, { useEffect, useState } from "react";
import Pe from "../images/dropableIcons/Pe.svg"
import Qe from "../images/dropableIcons/Qe.svg"

import DraggableLabel from "./DraggableLabel/index.js";
import DropableLabel from "./DropableLabel/index.js";
import "animate.css/animate.css";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "./graph1Styles.js"
import { isMobile } from "react-device-detect";

function Graph1Labels(props) {
  const { step,
    draggedLabels,
    onDragUpdate,
    onDragOffUpdate,
    onDragOffEnd,
    onDragEnd,
    setDraggableLabel,
    PeRef,
    QeRef,
    inPe,
    inQe,
    peLabel,
    qeLabel,
    submit,
    classes
  } = props;

  return (
    <>
      { step === 0 &&
        <div className={classes.labelContainer}>
          <h3 className={classes.headingText}>Drag the following labels to the graph:</h3>
          <div className={classes.innerlabelsContainer}>
            <h3 className={classes.labels}>Price at equilibrium</h3>
            {!draggedLabels.includes("Pe") &&
              <DraggableLabel
                image={Pe}
                onDragUpdate={onDragUpdate}
                onDragStart={() => console.log("started")}
                onDragEnd={onDragEnd}
                setDraggableLabel={setDraggableLabel}
                label={"Pe"}
                displayLabel={"P<sub>e</sub>"}
              />
            }
          </div>
          <div className={classes.innerlabelsContainer}>
            <h3 className={classes.labels}>Quantity at equilibrium</h3>
            {!draggedLabels.includes("Qe") &&
                <DraggableLabel
                  image={Qe}
                  onDragUpdate={onDragUpdate}
                  onDragStart={() => console.log("started")}
                  onDragEnd={onDragEnd}
                  left={"0%"}
                  setDraggableLabel={setDraggableLabel}
                  label={"Qe"}
                  displayLabel={"Q<sub>e</sub>"}
                />
              }
          </div>
        </div>
      }
      { step === 0 &&
      <div className={classes.DropableLabel1}>
        {/* targetY = 174 */}
          <DropableLabel
          aref={PeRef}
          inAnswer={inPe}
          isRight={true}
          // right={"46%"}
          onDragOffUpdate={onDragOffUpdate}
          onDragStart={() => console.log("started")}
          onDragOffEnd={onDragOffEnd}
          name={"Pe"}
          marginTop={ isMobile ? 94 : 170 }
          rotate={"rotate(0deg)"}
          label={peLabel}
          isSubmitted={submit}
          isCorrectLabel={peLabel==="Pe"}
        />

        <div className={classes.DropableLabel2}>
{/* targetY = 356 */}
          <DropableLabel
            aref={QeRef}
            inAnswer={inQe}
            isRight={true}
            // right={ "-40%" }
            // marginTop={ -44 }
            onDragOffUpdate={onDragOffUpdate}
            onDragStart={() => console.log("started")}
            onDragOffEnd={onDragOffEnd}
            name={"Qe"}
            rotate={"rotate(0deg)"}
            label={qeLabel}
            isSubmitted={submit}
            isCorrectLabel={qeLabel==="Qe"}
          />
        </div>
      </div>
      }
    </>
  )
}
export default withStyles(styles)(Graph1Labels);